import { styled } from '@mui/material/styles';

const StyledBlockQuote = styled('blockquote')(
  ({ theme }) => `

    position: relative;
    font-style: italic;
    border-left: 2px solid ${theme.DS_palette.border.quote};
    padding-left: ${theme.DS_spacing(['md'])};
    margin: ${theme.DS_spacing(['md'])} ${theme.DS_spacing(['md'])}  ${theme.DS_spacing(['lg'])}  ${theme.DS_spacing([
    'xs',
  ])} ;

  ${theme.breakpoints.up('md')} {
      margin-top: ${theme.DS_spacing(['lg'])};
    }
  `,
);

export { StyledBlockQuote };
